import { Model } from "@tailflow/laravel-orion/lib/model";

export class TaxType extends Model<{
  name: string;
}> {
  public $resource(): string {
    return "tax_types";
  }
}
